import { render, staticRenderFns } from "./Order-data.vue?vue&type=template&id=2f438cdd"
import script from "./Order-data.vue?vue&type=script&lang=js"
export * from "./Order-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports